import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './styles/theme.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {ThemeProvider} from "./context/ThemeContext";
import { noOrphansPlugin } from './utils/noOrphansPlugin';
import { HelmetProvider } from 'react-helmet-async';

// Inicjalizacja pluginu zapobiegającego wiszącym przyimkom i spójnikom
noOrphansPlugin();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <ThemeProvider>
        <App />
      </ThemeProvider>
    </HelmetProvider>
  </React.StrictMode>
);

reportWebVitals();
